/* HOT SALE México banner v2.1 - rotatório no topo */
(function(){
  'use strict';
  var VERSION = '2.1';
  var injected = false;
  console.log('[BellaSirena Banner] v' + VERSION + ' loaded');

  function isHomePage() {
    var main = document.getElementById('MainContent');
    if (main && main.dataset.template === 'index') return true;
    var path = window.location.pathname.replace(/\/+$/, '');
    return path === '' || path === '/' || /^\/[a-z]{2}(-[a-z]{2})?$/i.test(path);
  }

  function buildBanner() {
    var div = document.createElement('div');
    div.id = 'bs-promo-banner';
    div.className = 'bs-promo-banner';
    div.innerHTML =
      '<div class="bs-promo-banner__inner">' +
        '<span class="bs-promo-banner__icon">💕</span>' +
        '<div class="bs-promo-banner__text">' +
          '<strong>HOT SALE México 2x1</strong>' +
          '<span class="bs-promo-banner__sep">·</span>' +
          'Llévate <strong>2 bikinis</strong> y ahorra <strong>$119 MXN</strong>' +
          '<span class="bs-promo-banner__sep">·</span>' +
          '<em>Descuento automático al carrito</em>' +
        '</div>' +
      '</div>';
    return div;
  }

  function injectBanner() {
    if (!isHomePage()) return false;
    if (document.getElementById('bs-promo-banner')) { injected = true; return true; }

    var strategies = [
      function() {
        var hero = document.querySelector('.bs-hero, [class*="hero"]:first-of-type, .slideshow:first-of-type');
        if (hero && hero.parentNode) {
          hero.parentNode.insertBefore(buildBanner(), hero.nextSibling);
          return true;
        }
        return false;
      },
      function() {
        var main = document.getElementById('MainContent');
        if (main && main.firstChild) {
          main.insertBefore(buildBanner(), main.firstChild);
          return true;
        }
        return false;
      },
      function() {
        var headerGroup = document.getElementById('header-group');
        if (headerGroup && headerGroup.parentNode) {
          headerGroup.parentNode.insertBefore(buildBanner(), headerGroup.nextSibling);
          return true;
        }
        return false;
      },
      function() {
        var firstSection = document.querySelector('.shopify-section');
        if (firstSection && firstSection.parentNode) {
          firstSection.parentNode.insertBefore(buildBanner(), firstSection);
          return true;
        }
        return false;
      }
    ];

    for (var i = 0; i < strategies.length; i++) {
      try {
        if (strategies[i]()) {
          injected = true;
          console.log('[BellaSirena Banner] ✅ Inserted via strategy ' + (i+1));
          return true;
        }
      } catch(e) { console.warn('[BellaSirena Banner] strategy ' + (i+1) + ' err:', e); }
    }
    return false;
  }

  function run() {
    if (injected) return;
    try { injectBanner(); } catch(e) { console.error('[BellaSirena Banner] error:', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  [200, 600, 1500, 3000].forEach(function(ms) { setTimeout(run, ms); });
})();
